/**
 * Static mapping from stimulus filename key (used in pic_bbox) to SHA256 content hash
 * (used as Cloud Storage filename). Only used for old-style (desktop) evals.
 */
const STIMULI_HASH_MAP = {
  "CTRL1_01": "4d4d227e3787e996219e6964708270d0f078408e2fe4f1738c337a39a01a8720",
  "CTRL1_02": "1e9d1464fe2aab36b7fe87bf1542b44d4e595c1cac881656a109a4d4e7e009d4",
  "CTRL1_03": "d628ac234266684f257c2c9546e2a7a913d7a2ec84d7959a51c1d056bca11c23",
  "CTRL1_04": "b97c4af94d72e24302dccd65e1130f04eeb7b6becc6032d8c2a76447bc3ed8c9",
  "CTRL1_05": "6207b3e273e6463fa42c879ca4c855fb107f5e2d7d29bab761c30c8383a4e895",
  "CTRL1_06": "42fcc4d2438146f543719beddc56a0bc9cb3de81d563095695c9bbe5d178bc5a",
  "CTRL1_07": "54874c1d27a0773a57e2b8e1f7b5cb4484dd76f04dced48c2e1c9b75616de5db",
  "CTRL1_08": "1a231573d4c04d3aefaf3b68d0817867e4bb163cbf5c5acb1af0b56565a4cc8b",
  "CTRL1_09": "3310443401bba1f07d01f25edfcb84b176a4f153719caaca0029b3d420721c26",
  "CTRL1_10": "92dedf739439aef31cab61de56e8f88d3afc15fe58bb20e1957a667361ce2edc",
  "CTRL2_01": "061487dadb16b16fadcf30461ef6b57bbfa64258e769bfc95cfedff7d1816894",
  "CTRL2_02": "e8e778f1e2bb2a09d9f785851bf5e4a75ec0eff4926125217f6d9f5c82877b7d",
  "CTRL2_03": "8dafe4eb45805a3b5a2817df33bb42ce8bc1854366be25e7c98c01b47f29e5f6",
  "CTRL2_04": "1a3eac07a35b18b280c0638e636c4edb7a8a10862feb0b1cf15328cddcb52e69",
  "CTRL2_05": "f319875eeb2e5304cac828998778149d1701bf0cf3682467ad350682dd9cd66e",
  "CTRL2_06": "833c226a9e173e0d8043052c04ed65f6b84752b93d68254d4c9d137df6cd4882",
  "CTRL2_07": "b9131b8b293a2d025d2cb0a1e2b9ca5b062d75c37325b8d9598745f8d3349cd0",
  "CTRL2_08": "ebcfd4f3e77f0845b55edcd744a50d4715cf38a55fb4bfdeeb3a839843b3b119",
  "CTRL2_09": "b35bc57e600f616898ea5c311009a6afb4e4c8b0ef8a04446dc92a6f8a76d0d4",
  "CTRL2_10": "ec2f5e5034ff89e340528678ec58f19eafc0f3af3358cf2ba1de7e8e8c9313fa",
  "CTRL3_01": "80cc5924633d470a2e5f70dc0414be4aab21500a0f7dde549d53d7900c1ebe3c",
  "CTRL3_02": "fb89a4747bded82896e410cb46bd6b72bc3ad0b446e34b55af86f06d6893243b",
  "CTRL3_03": "4cb1a0c331e0a2a444cd9e2e71ec9cb18799fe69bf04f242b54b8314bccda83d",
  "CTRL3_04": "62f1203411a8b704d95b165b092667c6ead0a9b1ab05e2fcbb70a37180089fb0",
  "CTRL3_05": "abc1a2b400940089bb85fd0b0e5de5eeb56284721edc458ec5e725cc11cfeb4f",
  "CTRL3_06": "60e1f9db7d85a08e64e2dd59533c8676237db3163fbb43137663016b0db71c60",
  "CTRL3_07": "f8db3884dc1374021970b7609b1624c3026b990e7bc05205b842dde2d3c5d5f1",
  "CTRL3_08": "e07633d195cf1fe42077011b27109da7917de50b603de1bed93020fcf5efd0c6",
  "CTRL3_09": "5b6d743d460d20d02966694d1fc190550a08da2cbc3a1e2ef659203adebc7f98",
  "CTRL3_10": "fa728c6ea1591a5cd0146a000e6df367dda68aafbb1d78eba97c01a44bf60640",
  "CTRL4_01": "98a8f0dbfd6bc4127392ef30aafcccaa755b127e8401f6f9b9f08ef822f68d01",
  "CTRL4_02": "67d3f2f64db1ff9d0fd09a6236ecdd01b7c2ce9c98516909f4fbc91aa7e1ec40",
  "CTRL4_03": "aea9a2726625c7989467093a0229e3db980ee2479f5c9fb875be8c22007b96e3",
  "CTRL4_04": "1d5a3e066a4487c8764fabe8fe1f38248a7c21d9f0fffbcfc5fa936d86e5d086",
  "CTRL4_05": "d9a521c103fce898530cbaaad9a8de2118a0804a8c8b17ecc2b0bdc7a06c3533",
  "CTRL4_06": "cab1d40347807d4a6b3a1d766a1657aaee90d26d661dac56188cfe6068058a27",
  "CTRL4_07": "13ba0d2890ff71911cee96916f79054946cf7426ba89314cfbff34b9c393d018",
  "CTRL4_08": "999d11588741fb1c56eb651d0659d86b0a0f5a234160bd9ebcbc43209cb6fc46",
  "CTRL4_09": "c7940c9221530d202351f94a726efcbefeb7cb3c668db2581403e7ba25150f8f",
  "CTRL4_10": "7498e75fc973b3808a92470e56802ee0745f58c7413b6b19ecbd037bbd2de8ab",
  "T1_F_01": "3a2b3128b8c4ec26f211025124cb0bfb2f126b12b1f92e1fcd4da375dc81980e",
  "T1_F_02": "0e24e48a25509c3d13f963e24de2454a53cf2cecf8b76e3ca7d312af082d7048",
  "T1_F_03": "a3cb4512fca427a2fd49ef0bd4d283b6fdcbec0225728582f3714216a29eadda",
  "T1_F_04": "529feba10615bdd5138b16226f2430e3d9494cd8834b25cb11da072d00917f8c",
  "T1_F_05": "cb49487a39110f67bd259e936102b1b3b8e8e0b27b71bd3f633a96ee401ce60b",
  "T1_F_06": "36eea01cb7d4fc20ddced055b7694b61331e8348b0b393b1cfc7674ba006a472",
  "T1_F_07": "f962dd193c17959ad9f33bcb0dba434e5d7bb6c83c9b02024f166b49f916597b",
  "T1_F_08": "c0e676f29967c98e18dbef986d87556cfb8862b75eb2e94d141871146a1fe7d3",
  "T1_F_09": "4eec1dd481d851c22fe97edee10ea86e02fce2d18807d62b7e65b55c517babc9",
  "T1_F_10": "a655d5342157bcad59b526621603193a23412e4bbe5afc88f4ddaa9588cbe5cc",
  "T1_F_11": "69bb181ef9d6ddc3a7ee4b6017befb2b0a4b02e3269568910ce9751c6a9b9873",
  "T1_M_01": "c91019e1a0ac37a5b45401df73da04609369e36bc0d465a5711fa4259f84bd1f",
  "T1_M_02": "353b6dbaa23e96e8971ee1395826dfbd93ca706d8e402dad91347ee1564b5657",
  "T1_M_03": "87b24542cbad8796d58d8b114c33871993e5bf81be2eea9c739e3c614635d350",
  "T1_M_04": "9f44e491b5cc3901b8dd050083d4208818ba55fe56f3dbde18eea18874d36763",
  "T1_M_05": "f16fe0b604c3027e64baf89473a056bd14c3106ff34a2ff9807008ea835062fa",
  "T1_M_06": "64acea18d96346f5ef9e497e78c0b541a2f8547e32045f98384666ff560b79bc",
  "T1_M_07": "d312d55add16e556ea360101cdb5748a149ef638cf8dcb772481c50a4986f34a",
  "T1_M_08": "1846eb144378edbe546edf12273d43c60b44fc3814fdede0de28ea328e1c37f4",
  "T1_M_09": "21154e61bbcacac04e35a21f700d206150fa3b61028f1eddf4ac8b7678b12b2f",
  "T1_M_10": "dfa386b71113abbc2a8ca2eea406d7643dcb3432cefdd9ca8ac1567964a28cd7",
  "T1_M_11": "652fbd63eaee099d48cdb9eec3b85076ec18a3afcb5435e74ea2e067a383b665",
  "T2_F_01": "f3b91a68cf62123303bb577996a204a7ec4162048654848a60d9707b92666141",
  "T2_F_02": "1d55b6d9c50ce64c542d7563f0f005fe81c37c533fee3620bfd1a4ad5b9bc7d5",
  "T2_F_03": "c204e88925be856d1a5a9cacbc66e2cffca6ce9dc312abc93884a9a649fef48f",
  "T2_F_04": "bace22525b8b2a3e647956cb911373c5e1b5968bc05d2598fe4dc5c567fcd157",
  "T2_F_05": "915e9ce15427b044b824d02bf1366c333c664d91fe242c4fb108739fdd043344",
  "T2_F_06": "37388e9aed8908684d30084c355cc10cc978cb360e232eb471565fc811b5f601",
  "T2_F_07": "264d858dd1335a8d03086c6a0ce2f4b9b817799b6736c3126c6f9388ae8e2aed",
  "T2_F_08": "a0e718a7c2cec44a89e53c0ce7ca11e39a7e86dc666bbb2c42af9f949ef59998",
  "T2_F_09": "5eab9431a9678bf484ce3cc1c36fa815c37dbb037152ec67a6e4d0365fff3d27",
  "T2_F_10": "eaaa6114b0f6d1ffddcd7b390a8469e99697d7c01bdb70a3a5808882f869ceda",
  "T2_F_11": "6898137dc8a3a4cb1dffe8342593d55b7d489c666df580af61ae86cd5258e406",
  "T2_M_01": "52d73506fa3fbcdd03a5f4c40c83ae2a147864ade482576671091fe559de6ba2",
  "T2_M_02": "5f34ff33f4b7dbdea806ec97945952c619c434016106bfb13dee51a814a39bb3",
  "T2_M_03": "5e99c5b0107720fec2ac46f11e9a3ee2efec69f0cda4707c2d106d3440a90225",
  "T2_M_04": "79f77138e7806ab98d715c1402b7c2961c94f9011f01fd5c5e74612fe2631f8c",
  "T2_M_05": "fa4ccb241b620876665444dec97a14856bdc6ba3a52243ee47e87acf14a5d83d",
  "T2_M_06": "c160a8318f3fae301f1e3ec114677224e9cd36feba7f3a9f438ccc0a798aa4e5",
  "T2_M_07": "eceb695bfbc32712fae2375213224409ffbfe90fc4a5427fdb3f7687bec33d3c",
  "T2_M_08": "f5af0ef24f91f7afb7e0b44e20e43a4118354b7bcb06704a6287aca81f073133",
  "T2_M_09": "72d6003808d6b87173334f9ad4961653bcc99a7466c0aa23ea6e1ee213a523ba",
  "T2_M_10": "000ae996b1cd3bc53a16dd82e3cc4418d49adee595c51b568a17dd5f20d44d38",
  "T2_M_11": "7fdbddc80f270f1db870fe660eced319981d3f279bef661df8094b0598565598",
  "T3_F_01": "f7c4650ca60b1614d4d7176e9b877ec129cb7d9fdcc002895accbeb71bc6fcf4",
  "T3_F_02": "5e8a5b417fe02ac142e2895b5797b9cf59d0c339a0918c183c6cdf914f313c89",
  "T3_F_03": "745f02cc2b050495f3c86cc8ead4d6bd3f6985d299f47d6e13f62c5222069c32",
  "T3_F_04": "2018d7446c440a116aa8d11a095d617546efe9001ca3305c856f4a63940a500b",
  "T3_F_05": "3e304a63f06268f8ec5f7e1c8488d2ffcd0da1c0c6733dfc2ab35579874dc0af",
  "T3_F_06": "df2b5beede9524ae7b48387118a16e82e7218ec4eb8015150ef41f9ebc24d20e",
  "T3_F_07": "4f326b939e1054678ca2caaa0f7a986306391eb6ea2d08f2aebc60b1135d66e2",
  "T3_F_08": "78bea600adc7d220a485bc4ec335269e37e9f63bfd35fa735cba3c4c85e19683",
  "T3_F_09": "caa5403085ab860c740f6d445fb4d05a2b7154a85e5483ee9502a260ffa74db2",
  "T3_F_10": "afc23a09313fb6787167924f048fe16fb2b0698fece2e19c684c0d9089a0c572",
  "T3_F_11": "fcd8dff08aceea2a53d9caf955e76e486de0f8c042d0a30762acb06a8f928b74",
  "T3_M_01": "a992a8d84710fa7dc45e49f50cd6130cb4e9571c66abab73aabf7df7dd195a4e",
  "T3_M_02": "495f4104ada862ef242ad8305451a3310a59221d7e5329316e1e031d5491b68a",
  "T3_M_03": "7eb31783afaad45de92db4bfb9ca0d4e650c6b5fbd6891bcf145e23bc123618b",
  "T3_M_04": "563ec122c69064501db554a7869728866ea275949aeb887d5d87ae6646ed480a",
  "T3_M_05": "56d5490e02eea2a2b67a1545ebcb933bc8f159e6af40710801ba6dc26d6dbfb0",
  "T3_M_06": "3c4104bfd9995c94398dcc8849bda1bfcc366b01287f0f1672e7ee05d9e910fd",
  "T3_M_07": "c2bdf7eaf9c048f8dd9968ec20fe0b5b1197500abca32b23ddf9068618fadb0d",
  "T3_M_08": "47431cb23d7d555d699d391fa8e4340d69c1056c315f6351acd6f6a711d7d26f",
  "T3_M_09": "c63151d692ea582dabc98fb753f0ad302a78c89d5100301853d348de1a69b003",
  "T3_M_10": "6634b01d207f38da166f0bed1be0415f6b8f7361b7ca5bd7c985bd5e49f42181",
  "T3_M_11": "d2994db7c0684fb4ff511125573607de0ec6901c2dbaa38ca74e71054730b94e",
  "T4_F_01": "25e76e9abb9bab3a9b3fe246c841e422c9968d5b480c304ae49c9e0515b32ee9",
  "T4_F_02": "d957c96bce27e934de72fef083d0248ef1724ea4e04e4f0576df85459139ed7f",
  "T4_F_03": "4ff926333bf973f73332094e6bef1b63fef391c5b4e8484c69f50ca2ebdf49e4",
  "T4_F_04": "bc76a25921961bea57c90624278f0a438d27739183d47be386b5d99d2cb35c99",
  "T4_F_05": "d50127063a0bedf4462901ac8e8eb772669091a885d91fa87b247f364d3e0097",
  "T4_F_06": "1478ed6d029b194e6ba5194bf0d0f74ef88993fd25dbb3ab2d861e6cba581713",
  "T4_F_07": "39419467795e1cea26e1421bcfd49c87c48b7292c574e5614f245725bee44788",
  "T4_F_08": "97585fef4a3b5728f37f89989ebeea7cbd85e902be1dd92bafed154733226c94",
  "T4_F_09": "43c22d89c647780e76ff29fec265b2896de1e2e6b1b64675b452bb15d2c45a08",
  "T4_F_10": "a42edca192cd6d4e2c9582043d84b804559f06183a49a112cdd26e432d90035f",
  "T4_F_11": "64063a8ee178a040f259d896fed90b8db5961cb779682eb0b78cc567ff53e493",
  "T4_M_01": "1801c706cd3ee899e2ab412d1e5155fdbf2b89e2ed88bde6e3bc9840de9b0ea6",
  "T4_M_02": "d5064e7ab0cc584bc5eb8ad559ad56b4a45a6474f63182d24a78edcbe947fff7",
  "T4_M_03": "bbb537a5d99198c693e67821e66014d6b76dc02e41fa415d9ed1998e01bfe611",
  "T4_M_04": "c6848544f102f0ce39fccc7d150bfce604fb03c6acf004aeb6df4a8b88c8f927",
  "T4_M_05": "124e2e2035901242799bf58a37879d1c27d4089285eb61474fcce3318cb9bcd8",
  "T4_M_06": "c82e4ab7c419cdc1d75d7cb09a6de74194d23d5f68a26db1b1a212c7b18bd464",
  "T4_M_07": "83ea5c0784a943f10aa682584b063a741dafc30cc265f6e8bab1787bd67a1566",
  "T4_M_08": "5c968814d2a7b762c04201fbc427df25e404a4b72d7852cd43f58701491bfb2a",
  "T4_M_09": "bacc10d68f451cbe33954041ed89131801e130fae5fc2fe6d8d17bd2702c6fd6",
  "T4_M_10": "a9a9e7012aade13bd678209abd16a9c4977a969a523ad8f378ff80acaef13ae9",
  "T4_M_11": "cb26fc5fb9b00c2f9b48bad8e80565cad55b8cf6f40b06d5f3d0de3a0b1f97b3",
  "T5_F_01": "a87bfe382eb37f99cd4dd7aaef53b2f9da175d1640a28e2d22e3a28ff3e49ca9",
  "T5_F_02": "8d0780887c35ab8a71988d13dc50d01b21f97ff089cd5b800e9fa4ffdf742f97",
  "T5_F_03": "d63da46279b4dbe7cda8068a3cd09b87e954affad6c1a9363f16ac5857c2ccd6",
  "T5_F_04": "86728c4719f1b8110b52143ca6ce489c4a79a546ff0cd6fcfc0b2cb017d476c7",
  "T5_F_05": "df2f2cbec480497c70c96ad15f1b38a84de078d80a7e0958d530cb60b8dc5e33",
  "T5_F_06": "fa106a0be25c83cbbfcbe49ad84b6262d99900d3f31707568aff73e304cd771f",
  "T5_F_07": "f200a98dee46b1642e313cf8a92caf9143844f6d80a3cf2b7725b5ad65673865",
  "T5_F_08": "dfe7b62fe1b63519d7ff3957f40cf526a912bc6599092a73c51d7c040f11a3e6",
  "T5_F_09": "aa02f88e1554bb9f8ae6c3986f3feee479a96b457f27982357b1b43076e64d44",
  "T5_F_10": "e19d65372bc220ac4507bac28e26f9e6a1bff4a93acaa8f9e440e2454fc37cd6",
  "T5_F_11": "8c43a037d6c36441667e82a0473a803e13ab569a97cb0122cd1cb80dce8e28f3",
  "T5_M_01": "30921eb178ec44d84b93717d9be9705d5d12fe19daed5d3bebdffb1b9cf670c5",
  "T5_M_02": "fe73d8006e9eca322110b9b6befa71aab86974e789799f701e076f0a4ea7c915",
  "T5_M_03": "74d1c797036c4e7904f09d5fb7e7314a85ab45504c727a3e0f300837ca63867d",
  "T5_M_04": "6226d9b7f40468cd995468bc447c32d6c2ba9ad6c2cca5063962a2b16876ce83",
  "T5_M_05": "7d07620e55471ab298d22ec7240907e3611b2a757dcce04e99ed6ff0db95c8c2",
  "T5_M_06": "16f2abd217c06ccf8161f1eeb88d890d0efd997a350b2799244fc1fb35d253bd",
  "T5_M_07": "d80157dc14763881bcf8466fb01ffe370023d0ee46b43b3d48ab55b91d1e1d14",
  "T5_M_08": "f84c78c65c86ded7ba54bd9aa5be70f81045d65ab982cef6342186b0cea81f8b",
  "T5_M_09": "1a01f372e5faeb131fcb1f965e18d3bde3d29a9247f37929020e241348509136",
  "T5_M_10": "04527c3cce3d5e0e68bda469d79e4e3f866f884d2106222e405aeac9a3a4a2ab",
  "T5_M_11": "d46b485c62d462aa8595920e578a61686b02b41e12f0a0db61765403b454c220",
};

export default STIMULI_HASH_MAP;
